import { Route, Routes } from 'react-router-dom';
import { ReviewsPage } from './ReviewsPage';
import { UpdateReviewPage } from './UpdateReviewPage';

export const ReviewPageRoot = () => (
  <Routes>
    <Route path='/:reviewID' element={<UpdateReviewPage />} />
    <Route path='*' element={<ReviewsPage />} />
  </Routes>
);
